import React from 'react';
import './CollaborationDropdown.css';

const CollaborationDropdown = ({ collaborators = [], currentUser, connectionStatus, onClose, onInvite }) => {
  // Don't duplicate current user - they're separate from collaborators list
  const currentUserWithFlag = currentUser ? { ...currentUser, isCurrent: true, isOnline: true } : null;
  
  const onlineUsers = [
    ...(currentUserWithFlag ? [currentUserWithFlag] : []),
    ...collaborators.filter(c => c.isOnline)
  ];
  const offlineUsers = collaborators.filter(c => !c.isOnline);

  const handleBringToMe = () => {
    // TODO: Implement bring everyone to current file/cursor position
    console.log('Bring everyone to me - feature coming soon');
  };

  const getStatusText = (user) => {
    if (user.isCurrent) return 'Board owner';
    if (user.isOnline) return 'Viewing';
    return 'Offline';
  };

  const renderUser = (user, index) => (
    <div key={user.userId || index} className="dropdown-user">
      <div 
        className="dropdown-avatar" 
        style={{ backgroundColor: user.color || '#6366f1' }}
      >
        {(user.username || user.email)?.[0]?.toUpperCase()}
      </div>
      
      <div className="dropdown-user-info">
        <div className="user-name">
          {user.username || user.email}
          {user.isCurrent && <span className="you-badge"> (you)</span>}
        </div>
        <div className="user-status">
          {getStatusText(user)}
          {user.currentFile && (
            <span className="user-file"> • {user.currentFile}</span>
          )}
        </div>
      </div>

      {!user.isCurrent && (
        <button 
          className="user-action-btn"
          onClick={() => console.log('Navigate to user:', user.userId)}
          title="Go to this user's location"
        >
          ⤴
        </button>
      )}
    </div>
  );

  return (
    <div className="collaboration-dropdown">
      <div className="dropdown-header">
        <div className="dropdown-title">
          <span className="person-icon">👤</span>
          <span>Collaborators</span>
        </div>
        <button className="dropdown-close" onClick={onClose}>×</button>
      </div>

      <div className="dropdown-search">
        <input 
          type="text" 
          placeholder="Search by name" 
          className="search-input"
        />
      </div>

      <div className="dropdown-content">
        {/* Online Users */}
        {onlineUsers.length > 0 && (
          <div className="user-section">
            <div className="section-header">Online ({onlineUsers.length})</div>
            {onlineUsers.map(renderUser)}
          </div>
        )}

        {/* Offline Users */}
        {offlineUsers.length > 0 && (
          <div className="user-section">
            <div className="section-header">Offline ({offlineUsers.length})</div>
            {offlineUsers.map(renderUser)}
          </div>
        )}
      </div>

      <div className="dropdown-footer">
        <button 
          className="dropdown-invite-btn"
          onClick={() => {
            onInvite();
            onClose();
          }}
          disabled={connectionStatus !== 'connected'}
        >
          <span className="invite-icon">+</span>
          Invite to collaborate
        </button>
        <button 
          className="bring-everyone-btn"
          onClick={handleBringToMe}
          disabled={onlineUsers.length <= 1}
        >
          <span className="cursor-icon">🖱</span>
          Bring everyone to me
        </button>
      </div>
    </div>
  );
};

export default CollaborationDropdown;
